import CMS10125 from './CMS-10125';
import CMS10126 from './CMS-10126';
import CMS484 from './CMS-484';
import CMS846 from './CMS-846';
import CMS847 from './CMS-847';
import CMS848 from './CMS-848';
import CMS849 from './CMS-849';
import CMS854 from './CMS-854';
import Form1500 from './Form1500';
import Form150003 from './Form150003';
import PriorAuthorizationTemplateAffinityAuthorizationRequest from './Prior-Authorization-Template-Affinity-Authorization-Request';
import PriorAuthorizationTemplateFidelisAuthorizationRequest from './Prior-Authorization-Template-Fidelis-Authorization-Request';
import PriorAuthorizationTemplateHFAuthorizationRequest from './Prior-Authorization-Template-HF-Authorization-Request';
import PriorAuthorizationTemplateMetropolisAuthorizationRequest from './Prior-Authorization-Template-Metropolis-Authorization-Request';
import PriorAuthorizationTemplateWellcareAuthorizationRequest from './Prior-Authorization-Template-Wellcare-Authorization-Request';
import DeliveryTicketAOB from './Delivery-Ticket-AOB';
import DeliveryTicketCappedRental from './Delivery-Ticket-Capped-Rental';
import DeliveryTicketDeliveryInstructionsAndReceipt from './Delivery-Ticket-Delivery-Instructions-And-Receipt';
import DeliveryTicketDeliveryInstructionsAndReceiptOld from './Delivery-Ticket-Delivery-Instructions-And-Receipt-Old';
import DeliveryTicketDeliveryAndPickupReceipt from './Delivery-Ticket-Delivery-And-Pickup-Receipt';
import DeliveryTicketEquipmentWarrantyInformationForm from './Delivery-Ticket-Equipment-Warranty-Information-Form';
import DeliveryTicketPlanOfCareFittedServices from './Delivery-Ticket-Plan-Of-Care-Fitted-Services';
import DeliveryTicketInspectionRepair from './Delivery-Ticket-Inspection-Repair';
import DeliveryTicketPatientRightsAndResponsibilities from './Delivery-Ticket-Patient-Rights-And-Responsibilities';
import DeliveryTicketPlanOfCareRespiratory from './Delivery-Ticket-Plan-Of-Care-Respiratory';
import DeliveryTicketOrderConfirmationForm from './Delivery-Ticket-Order-Confirmation-Form';
import DeliveryTicketShipperForm from './Delivery-Ticket-Shipper-Form';
import HIPAAFormRequest from './HIPAA-Form-Request';
import DeliveryTicketABN from './Delivery-Ticket-ABN';
import WheelchairAssessment from './Wheelchair-Assessment';
import SAASAgreement from './SAAS-Agreement';
import FootMeasurementEvaluationForm from './Foot-Measurement-Evaluation-Form';
import PriorAuthorizationTemplateAlbaAuthorizationRequest from './Prior-Authorization-Template-Alba-Authorization-Request';
import PriorAuthorizationTemplateVillageCareAuthorizationRequest from './Prior-Authorization-Template-Village-Care-Authorization-Request';
import FaxCoverSheet from './Fax-Cover-Sheet';
import PrescriptionForm from './Prescription-Form';

export default [
  CMS10125,
  CMS10126,
  CMS484,
  CMS846,
  CMS847,
  CMS848,
  CMS849,
  CMS854,
  DeliveryTicketDeliveryInstructionsAndReceipt,
  DeliveryTicketDeliveryInstructionsAndReceiptOld,
  DeliveryTicketPatientRightsAndResponsibilities,
  DeliveryTicketAOB,
  DeliveryTicketEquipmentWarrantyInformationForm,
  DeliveryTicketCappedRental,
  DeliveryTicketDeliveryAndPickupReceipt,
  DeliveryTicketInspectionRepair,
  DeliveryTicketPlanOfCareFittedServices,
  DeliveryTicketPlanOfCareRespiratory,
  DeliveryTicketOrderConfirmationForm,
  DeliveryTicketShipperForm,
  Form1500,
  Form150003,
  PriorAuthorizationTemplateAffinityAuthorizationRequest,
  PriorAuthorizationTemplateFidelisAuthorizationRequest,
  PriorAuthorizationTemplateHFAuthorizationRequest,
  PriorAuthorizationTemplateMetropolisAuthorizationRequest,
  PriorAuthorizationTemplateWellcareAuthorizationRequest,
  HIPAAFormRequest,
  DeliveryTicketABN,
  WheelchairAssessment,
  SAASAgreement,
  FootMeasurementEvaluationForm,
  PriorAuthorizationTemplateAlbaAuthorizationRequest,
  PriorAuthorizationTemplateVillageCareAuthorizationRequest,
  FaxCoverSheet,
  PrescriptionForm,
];



// WEBPACK FOOTER //
// ./src/config/documents/index.js